import React, { useState, useEffect, useReducer } from "react"
import { connect } from "react-redux"

import { withTranslation } from "react-i18next"
import {
  addFileGasProject,
  addFileGasProjectSingle,
  stopGasProject,
  deleteGasProject,
  deselectGp,
  getGasProjectFiles,
  getGasProjectsFullFilter,
  getGppByGpId,
  getPackageInstaller,
  resetGasProjectFlag,
  resetPackage,
  selectGp,
  submitGasProjectAdmin,
  updateGasProject,
  updateGasProjectDetailsNew,
  sendSmsPayment,
  resolvedDefect,
  prepareForMapStage,
  prepareForFirstSupervisionStage,
  prepareForDesignStage,
  payByExecutorWallet,
  addPackageInstaller,
  sendGasProjectToGas,
  resetExecutorFlag,
} from "store/actions"
import { getCurrentUser, serializeQuery } from "helpers/service_helper"

import {
  Table,
  Pagination,
  Input,
  Space,
  Button,
  Row,
  Col,
  Card,
  Segmented,
  Typography,
  Flex,
  Badge,
  Tag,
  Tooltip,
} from "antd"
import {
  SearchOutlined,
  ReloadOutlined,
  FolderOutlined,
  FileSearchOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  WarningOutlined,
  SendOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons"
import { projectColumnsAnt } from "./ProjectColumnsAnt"
import { NumericInput } from "components/Common/NumericInput"

const { Search } = Input
const { Text, Title } = Typography

const ListGasProject = props => {
  const {
    lstGasProjectsFullFilter,
    lstGasProjectsFullFilterTotal,
    matches_sm,
    loading,
    onGetGasProjectsFullFilter,
    onDeselectGasProject,
    openNotification,
    reload,
    handleChangeExpand,
    userInfo,
    expanded,
  } = props

  const [errorMessage, setErrorMessage] = useState(null)
  const [pageSize, setPageSize] = useState(10)
  const [pageIndex, setPageIndex] = useState(1)
  const [dateCreated, setDateCreated] = useState("")
  const [filterCity, setFilterCity] = useState(false)
  const [isFirstRender, setIsFirstRender] = useState(true)

  const [dataAddress, setDataAddress] = useState({
    sectionId: 0,
    fullAddress: {
      pro: "",
      cit: "",
      sec: "",
      lat: 35.311308,
      lng: 46.991271,
      mainAddress: "",
    },
  })
  const [formInput, setFormInput] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      fileNumber: null,
      searchValue: "",
      projectLevelEnum: 100,
      isStop: false,
      firstPlanFilter: false,
      isoFilter: false,
      serialNumber: "",
    }
  )
  const handleInput = evt => {
    const name = evt.target.name
    let newValue = evt.target.value
    if (evt.target.type === "checkbox") newValue = evt.target.checked
    if (name === "projectLevelEnum") {
      onDeselectGasProject()
    }
    setFormInput({ [name]: newValue })
  }

  useEffect(() => {
    if (isFirstRender) {
      setIsFirstRender(false)
    } else {
      handleSearchGasProject("search")
    }
  }, [
    isFirstRender,
    formInput.projectLevelEnum,
    formInput.isStop,
    formInput.firstPlanFilter,
    formInput.isoFilter,
    formInput.serialNumber,
  ])

  useEffect(async () => {
    if (props.success) openNotification("success", "top", props.success)
    if (props.error) openNotification("error", "top", props.error)
    if (errorMessage) openNotification("warning", "top", props.error)
    if (props.success || props.error) {
      props.onResetGasProjectFlag()
      props.onResetExecutorFlag()
    }
  }, [errorMessage, props.success, props.error])

  useEffect(async () => {
    await handleSearchGasProject("pageIndex")
    console.log(getCurrentUser())
  }, [pageIndex, pageSize])

  useEffect(async () => {
    if (reload) {
      await handleSearchGasProject()
    }
  }, [reload])

  const handleSearchGasProject = async val => {
    if (val !== "pageIndex") onDeselectGasProject()
    let searchQuery = {
      ...formInput,
      page: val === "search" ? 1 : pageIndex,
      pageSize: val === "search" ? 10 : pageSize,
      fileNumber: formInput.fileNumber ? formInput.fileNumber : 0,
      solarRegisterDate: dateCreated?.persian ? dateCreated.persian : "",
      idSection: filterCity ? +dataAddress?.sectionId : 0,
      cityId: filterCity ? +dataAddress?.cityId : 0,
      exeName: formInput?.exeName ? formInput.exeName : "",
      landLordName: formInput?.landLordName ? formInput.landLordName : "",
      isStop: formInput.isStop,
      firstPlanFilter: formInput.firstPlanFilter,
      isoFilter: formInput.isoFilter,
      serialNumber: formInput.serialNumber,
    }
    const params = serializeQuery(searchQuery)
    onGetGasProjectsFullFilter(searchQuery)
  }

  const handleSizeChange = size => {
    setPageSize(size)
  }

  // Status filter options
  const statusOptions = [
    { value: 100, label: "همه", icon: <UnorderedListOutlined /> },
    { value: 0, label: "پیش ثبت نام", icon: <ClockCircleOutlined /> },
    { value: 1, label: "طراحی تایید شده", icon: <CheckCircleOutlined /> },
    { value: 3, label: "نقص", icon: <WarningOutlined /> },
    { value: 2, label: "آماده ارسال", icon: <SendOutlined /> },
  ]

  // Get status color
  const getStatusColor = status => {
    const colors = {
      100: "#667eea",
      0: "#fa8c16",
      1: "#52c41a",
      3: "#ff4d4f",
      2: "#1890ff",
    }
    return colors[status] || "#667eea"
  }

  return (
    <div style={{ padding: matches_sm ? 0 : 0 }}>
      {/* Header Card */}
      <Card
        size="small"
        style={{
          marginBottom: 12,
          borderRadius: 12,
          border: "none",
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          boxShadow: "0 4px 15px rgba(102, 126, 234, 0.3)",
        }}
        bodyStyle={{ padding: matches_sm ? 12 : 16 }}
      >
        <Flex justify="space-between" align="center" wrap="wrap" gap={12}>
          <Flex align="center" gap={10}>
            <div
              style={{
                width: 40,
                height: 40,
                borderRadius: 10,
                background: "rgba(255,255,255,0.2)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <FolderOutlined style={{ fontSize: 20, color: "#fff" }} />
            </div>
            <div>
              <Title
                level={5}
                style={{
                  margin: 0,
                  color: "#fff",
                  fontSize: matches_sm ? 14 : 16,
                }}
              >
                لیست پرونده‌ها
              </Title>
              <Text style={{ color: "rgba(255,255,255,0.8)", fontSize: 11 }}>
                مدیریت پرونده‌های گاز
              </Text>
            </div>
          </Flex>
          <Flex gap={8}>
            <Badge
              count={lstGasProjectsFullFilterTotal}
              overflowCount={999}
              style={{ backgroundColor: "#52c41a" }}
            >
              <Tag
                color="rgba(255,255,255,0.2)"
                style={{ color: "#fff", border: "none", borderRadius: 6 }}
              >
                کل پرونده‌ها
              </Tag>
            </Badge>
            <Tooltip title="بروزرسانی">
              <Button
                icon={<ReloadOutlined spin={loading} />}
                onClick={() => handleSearchGasProject("search")}
                style={{
                  borderRadius: 8,
                  background: "rgba(255,255,255,0.2)",
                  border: "none",
                  color: "#fff",
                }}
                size="small"
              />
            </Tooltip>
          </Flex>
        </Flex>
      </Card>

      {/* Filters Card */}
      <Card
        size="small"
        style={{
          marginBottom: 12,
          borderRadius: 12,
          border: "none",
          boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
        }}
        bodyStyle={{ padding: matches_sm ? 10 : 14 }}
      >
        {/* Status Segmented */}
        <div style={{ marginBottom: 12, overflowX: "auto", paddingBottom: 4 }}>
          <Segmented
            value={formInput.projectLevelEnum}
            onChange={value => setFormInput({ projectLevelEnum: value })}
            options={statusOptions.map(opt => ({
              value: opt.value,
              label: (
                <Flex
                  align="center"
                  gap={4}
                  style={{ padding: matches_sm ? "2px 4px" : "4px 8px" }}
                >
                  <span style={{ color: getStatusColor(opt.value) }}>
                    {opt.icon}
                  </span>
                  {!matches_sm && (
                    <span style={{ fontSize: 12 }}>{opt.label}</span>
                  )}
                  {matches_sm && (
                    <span style={{ fontSize: 11 }}>
                      {opt.label.split(" ")[0]}
                    </span>
                  )}
                </Flex>
              ),
            }))}
            style={{
              background: "#f5f5f5",
              borderRadius: 8,
              padding: 2,
            }}
            block={matches_sm}
          />
        </div>

        {/* Search Fields */}
        <Row gutter={[8, 8]} align="middle">
          <Col xs={12} sm={8} md={6} lg={4}>
            <NumericInput
              style={{ width: "100%", borderRadius: 8 }}
              value={formInput.fileNumber}
              name="fileNumber"
              onChange={handleInput}
              placeholder="شماره پرونده"
              size={matches_sm ? "middle" : "middle"}
            />
          </Col>
          <Col xs={12} sm={8} md={6} lg={4}>
            <Input
              name="landLordName"
              onChange={handleInput}
              placeholder="نام مالک"
              allowClear
              style={{ borderRadius: 8 }}
              size={matches_sm ? "middle" : "middle"}
            />
          </Col>
          <Col xs={24} sm={8} md={6} lg={4}>
            <Button
              type="primary"
              icon={<SearchOutlined />}
              onClick={() => handleSearchGasProject("search")}
              loading={loading}
              style={{
                borderRadius: 8,
                width: matches_sm ? "100%" : "auto",
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                border: "none",
              }}
              size={matches_sm ? "middle" : "middle"}
            >
              جستجو
            </Button>
          </Col>
        </Row>
      </Card>

      {/* Table Card */}
      <Card
        size="small"
        style={{
          borderRadius: 12,
          border: "none",
          boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
        }}
        styles={{
          body: {
            padding: matches_sm ? 8 : 12,
          },
        }}
      >
        <Table
          loading={loading}
          size="small"
          pagination={false}
          scroll={{ x: matches_sm ? 350 : 1200 }}
          sticky
          columns={projectColumnsAnt({
            props,
            setErrorMessage,
            currentUser: getCurrentUser(),
            matches_sm,
            pageIndex,
            pageSize,
            userInfo,
            expanded,
            handleChangeExpand,
            projectLevelEnum: formInput.projectLevelEnum,
          })}
          rowKey={record => record.id}
          dataSource={lstGasProjectsFullFilter}
          rowClassName={record => {
            if (record.isCancel) return "cancelled-row"
            return ""
          }}
          style={{
            borderRadius: 8,
          }}
        />

        {/* Pagination */}
        <Flex
          justify="space-between"
          align="center"
          style={{
            marginTop: 12,
            paddingTop: 12,
            borderTop: "1px solid #f0f0f0",
          }}
          wrap="wrap"
          gap={8}
        >
          <Text type="secondary" style={{ fontSize: 12 }}>
            <FileSearchOutlined style={{ marginLeft: 4 }} />
            تعداد کل:{" "}
            <Text strong style={{ color: "#667eea" }}>
              {lstGasProjectsFullFilterTotal}
            </Text>{" "}
            پرونده
          </Text>
          <Pagination
            current={pageIndex}
            total={lstGasProjectsFullFilterTotal}
            pageSize={pageSize}
            onChange={(page, size) => {
              setPageIndex(page)
              setPageSize(size)
            }}
            showSizeChanger
            showQuickJumper={!matches_sm}
            size="small"
            simple={matches_sm}
          />
        </Flex>
      </Card>
    </div>
  )
}

const mapStateToProps = ({
  GasProjects,
  USERs,
  GasProjectProcesses,
  Engineers,
  Executors
}) => ({
  lstGasProjectsFullFilter: GasProjects.lstGasProjectsFullFilter,
  lstGasProjectsFullFilterTotal: GasProjects.lstGasProjectsFullFilterTotal,
  lstGasProjectFiles: GasProjects.lstGasProjectFiles,
  lstPackageInstaller: GasProjects.lstPackageInstaller,
  lstEngineer: Engineers.lstEngineer,
  currentIdGasProject: GasProjects.currentIdGasProject,
  loading: GasProjects.loading,
  error: GasProjects.error || Executors.error,
  success: GasProjects.success || Executors.success,
  userBalance: USERs.userBalance,
  userInfo: USERs.userInfo,
  selectedProject: GasProjectProcesses.selectedProject,
})

const mapDispatchToProps = dispatch => ({
  onGetGasProjectsFullFilter: searchValue =>
    dispatch(getGasProjectsFullFilter(searchValue)),
  onResetGasProjectFlag: () => dispatch(resetGasProjectFlag()),
  onResetExecutorFlag: ()=>dispatch(resetExecutorFlag()),
  onGetProjectFiles: gasProjectId => dispatch(getGasProjectFiles(gasProjectId)),
  onAddFileGasProject: attachData => dispatch(addFileGasProject(attachData)),
  onAddFileGasProjectSingle: attachData =>
    dispatch(addFileGasProjectSingle(attachData)),
  onGetPackageInstaller: company => dispatch(getPackageInstaller(company)),
  onGetGppByGpId: gasProjectId => dispatch(getGppByGpId(gasProjectId)),
  onSelectGasProject: (gpId, selectArr) => dispatch(selectGp(gpId, selectArr)),
  onDeselectGasProject: () => dispatch(deselectGp()),
  onSubmitGasProjectByAdmin: gasProjectId =>
    dispatch(submitGasProjectAdmin(gasProjectId)),
  onResetPackage: gpId => dispatch(resetPackage(gpId)),
  onStopGasProject: data => dispatch(stopGasProject(data)),
  onUpdateGasProjectDetailsNew: process =>
    dispatch(updateGasProjectDetailsNew(process)),
  onUpdateGasProject: gasProject => dispatch(updateGasProject(gasProject)),
  onSendSmsPayment: data => dispatch(sendSmsPayment(data)),

  onDeleteGasProject: gasprojectId => dispatch(deleteGasProject(gasprojectId)),
  onResolvedDefect: data => dispatch(resolvedDefect(data)),
  onPrepareForMapStage: data => dispatch(prepareForMapStage(data)),
  onPrepareForFirstSupervisionStage: data =>
    dispatch(prepareForFirstSupervisionStage(data)),
  onPrepareForDesignStage: data => dispatch(prepareForDesignStage(data)),
  onPayByExecutorWallet: data => dispatch(payByExecutorWallet(data)),
  onAddPackageInstaller: gasProject =>
    dispatch(addPackageInstaller(gasProject)),
  onSendGasProjectToGas: fileNumber =>
    dispatch(sendGasProjectToGas(fileNumber)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(ListGasProject))
